import Patterns from '../patterns.js';

export default [
  {
    name: 'content.cs',
    label: {
      cs: 'Obsah [CS]',
      en: 'Content [CS]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 5096,
  },
  {
    name: 'content.en',
    label: {
      cs: 'Obsah [EN]',
      en: 'Content [EN]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 5096,
  },
  {
    name: 'label.cs',
    label: {
      cs: 'Popisek [CS]',
      en: 'Label [CS]',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'label.en',
    label: {
      cs: 'Popisek [EN]',
      en: 'Label [EN]',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'link',
    label: {
      cs: 'Odkaz',
      en: 'Link',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 128,
  },
];
